module.exports = __webpack_public_path__ + "media/qian.6df37e83.wav";